<template>
  <div id="app">
    <template v-if="$route.meta.onlyContent">
      <main class="main">
        <Transition mode="out-in" name="page">
          <RouterView :key="$route.fullPath" />
        </Transition>
      </main>
    </template>
    <template v-else>
      <vue-progress-bar />
      <HeaderComponent />
      <main class="main">
        <Transition mode="out-in" name="page">
          <RouterView :key="$route.fullPath" />
        </Transition>
      </main>
      <CallbackComponent v-if="!['home'].includes($route.name)" />
      <FooterComponent />
      <div @click="hideOverlay" :class="{ 'overlay--visible': isOverlayVisible }" class="overlay"></div>
      <MobileBottomMenuComponent />
      <Transition name="bounce">
        <ModalComponent />
      </Transition>
      <Transition name="slide">
        <MenuComponent />
      </Transition>
      <Notifications position="bottom right" />
      <CookiesComponent />
      <MessageButtonComponent />
    </template>
  </div>
</template>

<script>
import ModalComponent from "components/modals/index.vue";
import HeaderComponent from "components/header/index.vue";
import FooterComponent from "components/footer/index.vue";
import CallbackComponent from "components/CallbackComponent.vue";
import MobileBottomMenuComponent from "components/MobileBottomMenuComponent.vue";
import MenuComponent from "components/menus/index.vue";
import CookiesComponent from "components/CookiesComponent.vue";
import MessageButtonComponent from "components/MessageButtonComponent.vue";

export default {
  name: "App",
  created() {
    // Полоска загрузки
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
      this.hideOverlay();
    });
  },
  mounted() {
    this.$Progress.finish();
    // если пользователь не авторизован, то берем товары в корзине из localStorage
    if (!this.$store.state.apollo_token) {
      this.$store.state.auth.cart = localStorage.cartItems
        ? JSON.parse(localStorage.cartItems).filter((c) => c.item)
        : [];
    }
  },
  watch: {
    "$store.state.auth.cart"() {
      // обновляем localStorage при каждом изменении state.auth.cart
      localStorage.cartItems = this.$store.state.auth.cart ? JSON.stringify(this.$store.state.auth.cart) : [];
    },
    "$route.name"() {
      this.$store.state.variables = {};
    },
    "$route.params"() {
      this.$store.state.variables = {};
    },
  },
  computed: {
    isOverlayVisible() {
      return Object.keys(this.$store.state._overlays).some((k) => this.$store.state._overlays[k]);
    },
  },
  methods: {
    hideOverlay() {
      Object.keys(this.$store.state._overlays).forEach((key) => {
        this.$store.state._overlays[key] = false;
      });
    },
  },
  components: {
    MessageButtonComponent,
    CookiesComponent,
    MenuComponent,
    MobileBottomMenuComponent,
    CallbackComponent,
    ModalComponent,
    HeaderComponent,
    FooterComponent,
  },
  metaInfo: {
    titleTemplate: "%s | BabyMarket",
    meta: [
      {
        vmid: "keywords",
        name: "keywords",
        content: "BabyMarket, детские товары, baby market, бейбимаркет, бейби маркет, детские коляски",
      },
      {
        vmid: "description",
        name: "description",
        content: "Интернет магазин детских товаров.",
      },
      {
        vmid: "og:title",
        name: "og:title",
        content: "BabyMarket - интернет магазин детских товаров.",
      },
      {
        vmid: "og:description",
        name: "og:description",
        content: "Интернет магазин детских товаров.",
      },
      {
        vmid: "og:type",
        name: "og:type",
        content: "article",
      },
      {
        vmid: "og:image",
        name: "og:image",
        content: "https://babymarket.comrades.dev/static/images/logo.png",
      },
    ],
  },
};
</script>

<style lang="stylus">
@import 'styles/style.styl';
</style>
